var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: "sidebar-layout",
      class: { "overflow-hidden": !_vm.showSidebar },
      attrs: { id: "body", locale: _vm.$root.$i18n.locale },
    },
    [
      _vm.isOnThemePreviewMode ? _c("preview-theme-banner") : _vm._e(),
      _vm._v(" "),
      _c("page-sidebar", {
        attrs: { "show-sidebar": _vm.showSidebar },
        on: {
          "toggle-sidebar": function ($event) {
            _vm.showSidebar = !_vm.showSidebar
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.showSidebar ? "side-right offset-lg-2" : "mt-md-5 mt-3",
          attrs: { id: "page" },
        },
        [
          _c("account-usage-banner"),
          _vm._v(" "),
          _c("div", { attrs: { id: "main-content" } }, [_c("router-view")], 1),
          _vm._v(" "),
          _c("welcome-plan-information-modal", {
            attrs: { show: _vm.showWelcomeModal },
            on: {
              "update:show": function ($event) {
                _vm.showWelcomeModal = $event
              },
            },
          }),
          _vm._v(" "),
          _c("payment-failed-modal", {
            attrs: { show: _vm.showPaymentFailureModal },
            on: {
              "update:show": function ($event) {
                _vm.showPaymentFailureModal = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }